import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useOffline } from '../contexts/OfflineContext';
import { LogOut, Wifi, WifiOff, RefreshCw } from 'lucide-react';

export function Header({ title, showBack, onBack }) {
  const { user, logout } = useAuth();
  const { isOnline, pendingSync, syncData } = useOffline();
  const [syncing, setSyncing] = useState(false);

  const handleSync = async () => {
    if (syncing || !isOnline) return;
    setSyncing(true);
    try {
      await syncData();
      alert('Datos sincronizados correctamente');
    } catch (error) {
      alert(error.message);
    } finally {
      setSyncing(false);
    }
  };

  return (
    <header className="app-header" data-testid="app-header">
      <div className="flex items-center gap-4">
        {showBack && (
          <button
            onClick={onBack}
            className="h-12 w-12 flex items-center justify-center rounded-xl bg-zinc-100 active:bg-zinc-200"
            data-testid="header-back"
          >
            ←
          </button>
        )}
        <div>
          <h1 className="text-xl font-bold text-zinc-900" data-testid="header-title">{title}</h1>
          {user && <p className="text-sm text-zinc-600">{user.name}</p>}
        </div>
      </div>

      <div className="flex items-center gap-3">
        <div className={isOnline ? 'online-badge' : 'offline-badge'} data-testid="connection-status">
          {isOnline ? (
            <span className="flex items-center gap-1">
              <Wifi className="w-4 h-4" /> En línea
            </span>
          ) : (
            <span className="flex items-center gap-1">
              <WifiOff className="w-4 h-4" /> Sin conexión
            </span>
          )}
        </div>

        {pendingSync > 0 && (
          <button
            onClick={handleSync}
            disabled={!isOnline || syncing}
            className="h-12 px-4 flex items-center gap-2 rounded-xl bg-orange-100 text-orange-700 font-semibold active:bg-orange-200 disabled:opacity-50"
            data-testid="sync-button"
          >
            <RefreshCw className={`w-5 h-5 ${syncing ? 'animate-spin' : ''}`} />
            {pendingSync}
          </button>
        )}

        <button
          onClick={logout}
          className="h-12 w-12 flex items-center justify-center rounded-xl bg-zinc-100 active:bg-zinc-200"
          data-testid="logout-button"
        >
          <LogOut className="w-5 h-5 text-zinc-600" />
        </button>
      </div>
    </header>
  );
}
